export default class AiChatAdvice {

    public id = null;

    public assumedQuestion = "";

    public response = "";
}